<template>
  <img
    src="/sm/simge.png"
    alt="Scaling Master"
    height="40"
    width="40"
  >
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
